import React from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Typography,
  Grid,
  TextField,
  InputAdornment
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ScrollToTopBtn from "../common/ScrollToTop";
import { connect } from "react-redux";
import * as premiumApi from "../../api/premiumApi";
import { withParams } from "../common/WithParams";

class VintageByYearUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      vintages: [],
      page: 0,
      year: 0,
      rowsPerPage: 50,
      sortDirection: "asc",
      membership: props.type,
      searchQuery: "",
    };
  }

  async componentDidMount() {
    try {
      const user = this.props.signedinuser;
      this.setState({ user });
      this.fetchVintagesByYear(user.companyId);
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {

      const membership = this.props.type;
      this.setState(
        {
          vintages: [],
          page: 0,
          rowsPerPage: 50,
          sortDirection: "asc",
          membership,
        },
        () => {
          this.fetchVintagesByYear();
        }
      );
    }
  }

  async fetchVintagesByYear(companyId) {
    try {
      const year = this.props.params.year;
      const vintages = await premiumApi.getVintagesByYear(this.state.membership, year, companyId);
      if (vintages) {
        this.setState({ vintages });
      }
      this.setState({ year })
    } catch (error) {
      console.log("Error in fetchVintagesByYear", error);
    }
  }

  handleChangePage = (_event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  compareBy = (key, direction) => {
    return function (a, b) {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, vintages } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...vintages].sort(this.compareBy(key, newDirection));
    this.setState({ vintages: sortedArray, sortDirection: newDirection });
  };

  handleDownload = async () => {
    await premiumApi.getExcelFile(this.state.membership, this.state.year, this.state.user.companyId, true);
  };

  handleSearch = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  render() {
    const { searchQuery, membership, vintages, year, page, rowsPerPage } = this.state;

    const columns = [
      { id: "vismer", label: "", align: "center" },
      { id: "prizeYear", label: "ÅR" },
      { id: "companyName", label: "Bedrift" },
      {
        id: "repPrizes",
        label: "Rapportert beløp",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "repPercent",
        label: "Rapportert Andel i %",
        align: "right",
        format: (value) =>
          value.toLocaleString("de-DE", {
            maximumSignificantDigits: 4,
          }),
      },
      {
        id: "ownedPrizes",
        label: "Eide beløp",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "ownedPercent",
        label: "Eide andel i %",
        align: "right",
        format: (value) =>
          value.toLocaleString("de-DE", {
            maximumSignificantDigits: 4,
          }),
      },
      { id: "", label: "" },
    ];

    const layout = {
      width: "100%",
      paddingTop: 80,
    };
    const tableWrapper = {
      marginTop: 10,
      overflow: "auto",
    };
    const headStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };
    const linkStyle = {
      textDecoration: "none",
      color: "#673ab7",
    };
    const buttonStyle = {
      margin: "8px 0",
    };
    const emptyPaperStyle = {
      paddingTop: 45,
      paddingLeft: 50,
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layout}>

            {/* Title */}
            <Typography variant="h5" sx={{ mb: 2 }}>
              Premier for {year}
            </Typography>

            <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>

              <Grid item>
                <TextField
                  placeholder="Søk"
                  variant="standard"
                  sx={{ width: "250px", backgroundColor: "white", borderRadius: 1 }}
                  value={searchQuery}
                  onChange={this.handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={buttonStyle}
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handleDownload}
                >
                  Vis i Excel
                </Button>
              </Grid>
            </Grid>

            <Paper>
              <div style={tableWrapper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column, index) => (
                        <TableCell
                          key={index}
                          align={column.align}
                          style={{ ...headStyle, cursor: "pointer" }}
                          onClick={() => this.sortBy(column.id)}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vintages && vintages.length > 0 ? (
                      vintages
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage +
                          rowsPerPage
                        )
                        .map((vintage, index) => (
                          <TableRow key={index} hover>
                            {columns.map((column, columnIndex) => {
                              let value = vintage[column.id];

                              if (column.id === "vismer") {
                                return (
                                  <TableCell key={columnIndex} align={column.align}>
                                    <Link
                                      // TODO: Make premium detail not show information about other companies when a "årgang" is open
                                      // Cause some errors, and it appear to the user they can edit others sumbissions
                                      // Even if that is not the case
                                      // I an not sure if even a user should be allowed to view other companies avregninger
                                      to={`/premiumdetail${membership.toLowerCase()}/${vintage.prizeYear}`}
                                      style={linkStyle}
                                    >
                                      <Button
                                        variant="outlined"
                                        size="medium"
                                        color="primary"
                                        style={{ margin: 2 }}
                                      >
                                        <ArrowRightIcon style={{ marginRight: 4 }} />
                                        Vis
                                      </Button>
                                    </Link>
                                  </TableCell>
                                );
                              } else {
                                return (
                                  <TableCell key={columnIndex} align={column.align}>
                                    {column.format && typeof value === "number"
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              }
                            })}
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={columns.length}>
                          <Typography style={emptyPaperStyle}>Ingen treff</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={vintages.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser: signedinuser };
}

export default withParams(connect(mapStateToProps)(VintageByYearUser));
